module.exports = __webpack_public_path__ + "media/images/header_icon_arrow-229129d245addaee55845cd96e848850.png";